export const FORMAT_DATE_ISO_SHORT = 'YYYY-MM-DD'; // handle dates in this format as data: 2021-01-01
export const DEFAULT_TICKER_ALLOCATION_DATE = '1999-12-31'; // default date for benchmark (as ISO string)
export const FORMAT_DATE_UI = 'DD/MM/YYYY'; // show dates in this format for ui: 01/01/2021

